const openExplorer = async (theapp, tx_info) => {
	console.log('openExplorer called');

	let mvcmywidget = theapp.getMvcMyWidget();
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;
	
	var uri = start_conditions.explorer_url + '/tx/' + (tx_info ? tx_info.hash : '');

	var options = {};

	if (start_conditions.pop_up === true) {
		options.pop_up = true;;
	}

	theapp.gotoUrl(uri, options);
}

export default openExplorer;